module.exports = __webpack_public_path__ + "static/media/job_category_7.05463900.png";